module.exports = __webpack_public_path__ + "img/logo_tu_braunschweig.cf71de58.svg";